import collectionReducer from '../collectionReducer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ReducerCreator = (config: any) => any;

export default (collectionReducer as unknown as ReducerCreator)({
    apiCollectionName: 'sc-connections',
    collectionActionName: 'SC_CONNECTIONS',
    identifier: 'scCode',
    itemActionName: 'SC_CONNECTION',
});
